import { createApi, retry } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "api";

const baseQueryWithRetry = retry(baseQuery, { maxRetries: 0 });
export const favoriteApi = createApi({
  reducerPath: "favoriteApi",
  baseQuery: baseQueryWithRetry,
  keepUnusedDataFor: 60 * 5,
  endpoints: (build) => ({
    addFavoriteLottery: build.mutation({
      query: (credentials) => {
        return {
          url:
            process.env.REACT_APP_MALL_API_URL + `/users/self/lottery/bookmark`,
          method: "POST",
          body: {
            shop_id: credentials.shop_id,
            lottery_id: credentials.lotttery_id,
          },
        };
      },
      transformResponse: (response) => {
        return response;
      },
    }),
    removeFavoriteLottery: build.mutation({
      query: (credentials) => ({
        url:
          process.env.REACT_APP_MALL_API_URL + `/users/self/lottery/bookmark`,
        method: "DELETE",
        body: {
          shop_id: credentials.shop_id,
          lottery_id: credentials.lotttery_id,
        },
      }),
      transformResponse: (response) => {
        return response;
      },
    }),
    checkFavoriteLottery: build.query<any, { lottteryID: number }>({
      query: (arg) => {
        const { lottteryID } = arg;
        return {
          url:
            process.env.REACT_APP_MALL_API_URL +
            `/users/self/lottery/bookmark/${lottteryID}`,
          validateStatus: (response, result) =>
            response.status === 200 && !result.isError,
        };
      },
      transformResponse: (response) => {
        return response;
      },
    }),
  }),
});

export const {
  useAddFavoriteLotteryMutation,
  useRemoveFavoriteLotteryMutation,
  useCheckFavoriteLotteryQuery,
} = favoriteApi;
